// Helper to show invalid feedback according to Joi errors and field given

import PropTypes from 'prop-types'

function InvalidFeedback ({ errors, field }) {
  if (errors && errors[field]) {
    return <div className='invalid-feedback d-block'>{errors[field]}</div>
  } else {
    return null
  }
}

InvalidFeedback.propTypes = {
  errors: PropTypes.object,
  field: PropTypes.string
}

export default InvalidFeedback
